import { GridColDef } from "@mui/x-data-grid-premium";
import { JobCategory_Entity } from "../../../entities/jobCategory";
import { toScaledInteger } from "../../../helpers/numberHelpers";

export const getBenefitsColumnDef = (
  jobCategories: JobCategory_Entity[]
): GridColDef[] => {
  return [
    {
      field: "jobCategoryID",
      headerName: "Job Category",
      width: 120,
      editable: false,
      type: "string",
      valueFormatter: (valueOrParams: any) =>
        jobCategories.find((jc) => jc.id === (valueOrParams?.value ?? valueOrParams))
          ?.name,
    },
    {
      field: "pension",
      headerName: "Pension",
      editable: true,
      type: "number",
      valueGetter: getterDivider("pension", 10000),
      valueSetter: setterDivider("pension", 10000),
      valueFormatter: (valueOrParams: any) =>
        `${valueOrParams?.value ?? valueOrParams}%`,
    },
    {
      field: "vacation",
      headerName: "Vacation",
      editable: true,
      type: "number",
      valueGetter: getterDivider("vacation", 10000),
      valueSetter: setterDivider("vacation", 10000),
      valueFormatter: (valueOrParams: any) =>
        `${valueOrParams?.value ?? valueOrParams}%`,
    },
    {
      field: "flexDivisor",
      headerName: "F Divisor",
      editable: true,
      type: "number",
      valueGetter: getterDivider("flexDivisor", 10000),
      valueSetter: setterDivider("flexDivisor", 10000),
      valueFormatter: (valueOrParams: any) =>
        `${valueOrParams?.value ?? valueOrParams}`,
    },
    {
      field: "flexMultiplier",
      headerName: "F Multiplier",
      editable: true,
      type: "number",
      valueGetter: getterDivider("flexMultiplier", 10000),
      valueSetter: setterDivider("flexMultiplier", 10000),
      valueFormatter: (valueOrParams: any) =>
        `${valueOrParams?.value ?? valueOrParams}`,
    },
    {
      field: "flexDayHours",
      headerName: "F Day Hours",
      editable: true,
      type: "number",
      valueGetter: getterDivider("flexDayHours", 100),
      valueSetter: setterDivider("flexDayHours", 100),
      valueFormatter: (valueOrParams: any) =>
        `${valueOrParams?.value ?? valueOrParams}`,
    },
  ];
};

export const getterDivider =
  (key: string, multipler: number) =>
  (valueOrParams: any, rowArg?: any) => {
    const row = rowArg ?? valueOrParams?.row;
    if (!row) return undefined;
    return row[key] / multipler;
  };

export const setterDivider =
  (key: string, multipler: number) =>
  (valueOrParams: any, rowArg?: any) => {
    const value =
      valueOrParams &&
      typeof valueOrParams === "object" &&
      "value" in valueOrParams
        ? valueOrParams.value
        : valueOrParams;
    const row = rowArg ?? valueOrParams?.row;
    if (!row) return row;
    const parsed =
      value === "" || value === null || value === undefined
        ? 0
        : Number(value);
    if (!Number.isFinite(parsed)) return row;
    return { ...row, [key]: toScaledInteger(parsed, multipler) };
  };
